module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MediaGridItemText",
    style: (_vm.mainElementStyles)
  }, [(_vm.data.title) ? _c('h1', {
    staticClass: "MediaGridItemText-title t-heading-sm"
  }, [_vm._v("\n    " + _vm._s(_vm.data.title) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.data.subtitle) ? _c('p', {
    staticClass: "MediaGridItemText-subtitle t-text-sm"
  }, [_vm._v("\n    " + _vm._s(_vm.data.subtitle) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.data.text) ? _c('markdown', {
    staticClass: "MediaGridItemText-text t-text-sm",
    attrs: {
      "content": _vm.data.text
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbe354ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaGridItemText.vue
// module id = 800
// module chunks = 1474